import axios from 'axios';
import getCookie from '../util/getCookie';
import { ACCESS_TOKEN_MA, INSTANCE_TOKEN } from './reqConstants';

const loadIcons = ({ navigationApiUrl, iconPackId }) => {
    const tokenMa = getCookie(ACCESS_TOKEN_MA);
    const instanceToken = getCookie(INSTANCE_TOKEN);
    const headers = {
        ...(tokenMa && { Authorization: tokenMa }),
        ...(instanceToken && { Instance: instanceToken })
    };

    const url = `${navigationApiUrl}/asset-manager-api/v1/icon-packs/${iconPackId}`;

    return axios.get(url, { headers })
        .then(res => (res.data))
        .catch(() => null);
};

export default loadIcons;
